module.exports = __webpack_public_path__ + "z.no1.9ad3df8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/z.no1.jpg
// module id = 26gG
// module chunks = 0